import { getCOLORS } from "@hdi-seguros/web-components.theme-config-provider";

const colors = getCOLORS();

export const COLORS = {
    ...colors
};